<script>
import Digital300x250 from "@/components/previews/digital-300x250";
import Digital160x600 from "@/components/previews/digital-160x600";
import Digital320x50 from "@/components/previews/digital-320x50";
import Facebook from "@/components/previews/facebook";
import Native from "@/components/previews/native";

export default {
  components: {
    Digital300x250,
    Digital160x600,
    Digital320x50,
    Facebook,
    Native
  },
  data () {
    return {
      data: null
    }
  },
  mounted()  {
   this.apiGetPublic(`/campaigns/${this.$route.params.campaignNameSlug}/public/${this.$route.params.businessTypeSlug}`).then((data) => {
     this.data = data
   })
  },
  methods: {
    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  }
}
</script>

<template>
  <div v-if="data" class="container">
    <div class="row mt-3 mb-3">
      <div class="col-12 col-md-6">
        <h1 class="h2 mb-0">{{ data.name }}</h1>
      </div>
      <div class="col-12 col-md-6">
        <div class="order-confirmation__link-wrapper">
          <b-button variant="link" :href="data.landingPageUrl" v-if="data.landingPage" target="_blank" rel="noopener" class="mr-2">Preview Campaign Landing Page</b-button>
          <b-button variant="primary" :href="`mailto:${data.createdBy.email}?subject=Approved campaign - ${data.name}`">
            Contact your Sales Rep about this campaign
          </b-button>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-12 col-md-3" v-if="data.package.type === 'Print & digital' || data.package.type === 'Digital'">
                <img :src="data.campaignImages[0].image.url" class="w-100">
              </div>
              <div class="col-12 col-md-6 order-confirmation__list">
                <h5>Package: <span class="text-muted">{{ data.package.name }}</span></h5>
                <h5>Type: <span class="text-muted">{{ data.package.type }}</span></h5>
                <h5>Masthead: <span class="text-muted">{{ data.package.masthead.name }}</span></h5>
                <h5>Status: <span class="text-muted">{{ data.status }}</span></h5>
                <h5>Start Date: <span class="text-muted">{{ data.startDate | formatDate }}</span></h5>
                <h5>Investment (inc GST): <span class="text-muted">{{ data.campaignOrder ? data.campaignOrder.priceIncludingGst : data.package.priceIncludingGst | formatCurrency }}</span></h5>
              </div>
              <div class="col-12 col-md-3" v-if="data.package.type === 'Video'"></div>
              <div class="col-12 col-md-3 order-confirmation__masthead-logo">
                <img v-if="data.package.masthead.logoImage" :src="data.package.masthead.logoImage.url" class="w-75" />
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-12 col-md-6 col-lg-3" v-if="data.package.type === 'Print & digital'">
                <div class="d-flex flex-column justify-content-center bg-soft-primary rounded px-2 py-3 text-center mb-3">
                  <p>Insertions</p>
                  <h5 class="mb-0">{{ data.package.totalInsertions }}</h5>
                </div>
              </div>
              <div class="col-12 col-md-6 col-lg-3" v-if="data.package.type === 'Print & digital'">
                <div class="d-flex flex-column justify-content-center bg-soft-primary rounded px-2 py-3 text-center mb-3">
                  <p>Size</p>
                  <h5 class="mb-0">{{ data.package.printSize }}</h5>
                </div>
              </div>
              <div class="col-12 col-md-6 col-lg-3" v-if="data.package.type === 'Print & digital'">
                <div class="d-flex flex-column justify-content-center bg-soft-primary rounded px-2 py-3 text-center mb-3">
                  <p>Section</p>
                  <h5 class="mb-0">{{ data.package.earlyGeneralNews }}</h5>
                </div>
              </div>
              <div class="col-12 col-md-6 col-lg-3">
                <div class="d-flex flex-column justify-content-center bg-soft-primary rounded px-2 py-3 text-center mb-3">
                  <p>Digital Impressions</p>
                  <h5 class="mb-0">{{ data.package.impressions | formatNumberWithCommas }}</h5>
                </div>
              </div>
            </div>
            <p class="mb-0" v-if="data.package.type === 'Print & digital'">
              If campaign assets are new, print artwork will be sent through to you by your sales representative for approval in the coming days.
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-body">
        <div>
          <h2 lass="mb-4">Creative Preview</h2>
        </div>
        <div class="row" v-if="data.package.type === 'Digital' || data.package.type === 'Print & digital'">
          <div class="col-12 col-lg-6 mb-4">
            <h5 class="mb-3">Digital Ad - 300x250</h5>
            <div class="d-flex w-100 justify-content-center">
              <div class="creative-preview-modal__component-wrapper">
                <digital-300x250 :campaign="data" />
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-6 mb-4">
            <h5 class="mb-3">Digital Ad - 160x600</h5>
            <div class="d-flex w-100 justify-content-center">
              <div class="creative-preview-modal__component-wrapper">
                <digital-160x600 :campaign="data" />
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-6 mb-4">
            <h5 class="mb-3">Digital Ad - 320x50</h5>
            <div class="d-flex w-100 justify-content-center">
              <div class="creative-preview-modal__component-wrapper">
                <digital-320x50 :campaign="data" />
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-6 mb-4">
            <h5 class="mb-3">Facebook Ad</h5>
            <div class="d-flex w-100 justify-content-center">
              <div class="creative-preview-modal__component-wrapper">
                <facebook :campaign="data" />
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-6 mb-4">
            <h5 class="mb-3">Native Ad</h5>
            <div class="d-flex w-100 justify-content-center">
              <div class="creative-preview-modal__component-wrapper">
                <native :campaign="data" />
              </div>
            </div>
          </div>
        </div>
        <div class="row" v-else-if="data.package.type === 'Video'">
          <div class="col-12">
            <iframe class="order-confirmation__video-iframe" :src="data.campaignVideo.url" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>